import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Survey from "./views/staticPage/Survey.vue";
import store from "./store";
import acctmgmt from "./views/Acctmgmt.vue";
import account from "./views/Account";
import HealthHistory from "./views/EditHealthHistory";
import clinicalTrial from "./views/ClinicalTrial";
import geneticTestingResults from "./views/GeneticTestResult";
import resources from "./views/Resources";
import familyHistory from "./views/FamilyHistory";
import editor from "./views/Editor";
import Form from "./views/Form";
import Upload from "./views/Upload"
import Questionairre from "./views/Form.vue";
import HealthQuestionairre from "./views/HealthForm.vue";
import StaticHome from "./views/staticPage/Home";
import StaticPlus from "./views/staticPage/Plus";
import StaticComplete from "./views/staticPage/Complete";
import StaticConcierge from  "./views/staticPage/Concierge";
import redirectSignup from "./views/redirectSignup";
import RedirectPassword from "./views/RedirectPassword";
import Messaging from "./views/Messaging";
import DNABankingInfo from "./views/DNABankingInfo";
import NotFound from "./views/common/404";
import report from "./views/Report"
import FamilyHistoryCollection from "./views/familyHistoryCollection"
import MedicalRecordsCollectionGuide from "./views/MedicalRecordsCollectionGuide"
import FamilyTreeWorksheet from "./views/FamilyTreeWorksheet"
import publicFamilyTreeWorksheet from "./views/public/FamilyTreeWorksheet"
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/public/home",
      name: "staticHome",
      component: StaticHome
    },
    {
      path: "/",
      redirect: '/public/home'
    },
    {
      path: "/public/plus",
      name: "staticPlus",
      component: StaticPlus
    },
    {
      path: "/public/complete",
      name: "StaticComplete",
      component: StaticComplete
    },
    {
      path: "/public/concierge",
      name: "StaticConcierge",
      component: StaticConcierge
    },
    {
      path: "/public/familytree",
      name: "publicFamilyTreeWorksheet",
      component: publicFamilyTreeWorksheet
    },
    {
      path: "/onboarding/completesignup",
      name: "redirectSignup",
      component: redirectSignup
    },
    {
      path: "/onboarding/redirectPassword",
      name: "RedirectPassword",
      component: RedirectPassword
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/survey",
      name: "survey",
      component: Survey
    },
    {
      path: "/upload",
      name: "upload",
      component: Upload,
      meta: { requiresAuth: true }
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: "/resources",
      name: "resources",
      component: resources,
      meta: { requiresAuth: true }
    },
    {
      path: "/questionnaire",
      name: "Questionairre",
      component: Questionairre,
      meta: { requiresAuth: true }
    },
    {
      path: "/healthquestionnaire",
      name: "HealthQuestionairre",
      component: HealthQuestionairre,
      meta: { requiresAuth: true }
    },
    {
      path: "/account",
      name: "account",
      component: account,
      meta: { requiresAuth: true }
    },
    {
      path: "/messaging",
      name: "messaging",
      component: Messaging,
      meta: { requiresAuth: true }
    },
    {
      path: "/bankingInfo",
      name: "bankingInfo",
      component: DNABankingInfo,
      meta: { requiresAuth: true }
    },
    {
      path: "/healthhistory",
      name: "healthHistory",
      component: HealthHistory,
      meta: { requiresAuth: true }
    },
    {
      path: "/acctmgmt",
      name: "accountManagement",
      component: acctmgmt,
      meta: { requiresAuth: true }
    },
    {
      path: "/clinical",
      name: "clinical",
      component: clinicalTrial,
      meta: { requiresAuth: true }
    },
    {
      path: "/genetictesting",
      name: "genetictesting",
      component: geneticTestingResults,
      meta: { requiresAuth: true }
    },
    {
      path: "/form/:formType",
      name: "form",
      component: Form,
      meta: { requiresAuth: true }
    },
    {
      path: "/familyHistory",
      name: "familyHistory",
      component: familyHistory,
      meta: { requiresAuth: true }
    },
    {
      path: "/editor",
      name: "editor",
      component: editor,
      meta: { requiresAuth: true }
    },
    {
      path: "/report",
      name: "report",
      component: report,
      meta: { requiresAuth: true }
    },
    {
      path : "/familyHistoryCollection",
      name : "FamilyHistoryCollection",
      component : FamilyHistoryCollection,
      meta: { requiresAuth: true }
    },
    {
      path : "/medicalRecordsCollectionGuide",
      name : "medicalRecordsCollectionGuide",
      component : MedicalRecordsCollectionGuide,
      meta: { requiresAuth: true }
    },
    {
      path : "/FamilyTreeWorksheet",
      name : "FamilyTreeWorksheet",
      component : FamilyTreeWorksheet,
      meta: { requiresAuth: true }
    },
    
    { path: '*', component: NotFound }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    } else {
      next({
        path: "/"
      });
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
